import React from 'react';
import { Linkedin, Mail } from 'lucide-react';
import { companyInfo } from '../data/mock';

const MeetTheTeam = () => {
  // Team members data
  const teamMembers = [
    {
      id: 1,
      name: "Tristan",
      role: "Founder & Director",
      bio: "Leading HappyVan with a passion for exceptional customer service and making moves stress-free.",
      image: "https://customer-assets.emergentagent.com/job_c029ed7e-4912-4699-9c60-973c3a0c773a/artifacts/17jmmqmc_Tristan.jpg",
      email: companyInfo.email
    },
    {
      id: 2,
      name: "Dom",
      role: "Senior Mover",
      bio: "Ensuring every move runs smoothly from start to finish with years of experience.",
      image: "https://customer-assets.emergentagent.com/job_c029ed7e-4912-4699-9c60-973c3a0c773a/artifacts/e9v5sr5r_Dom.jpg",
      email: null
    },
    {
      id: 3,
      name: "Alfie",
      role: "Lead Mover",
      bio: "Expert in handling your belongings with care and precision.",
      image: "https://customer-assets.emergentagent.com/job_c029ed7e-4912-4699-9c60-973c3a0c773a/artifacts/9dbe1nik_Alfie.jpg",
      email: null
    }
  ];

  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#3B43AF] font-semibold text-sm uppercase tracking-wider mb-3">Our Team</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Meet the Team</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            The friendly faces behind HappyVan. We're dedicated to making your move as smooth as possible.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member) => (
            <div 
              key={member.id}
              className="group text-center"
            >
              {/* Photo Container - Rounded portrait shape */}
              <div className="relative mb-6 mx-auto w-48 h-64 overflow-hidden rounded-3xl bg-gray-50 shadow-lg group-hover:shadow-xl transition-all duration-500">
                {member.image ? (
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                ) : (
                  // Placeholder when no image
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-indigo-100 to-indigo-200">
                    <div className="text-center">
                      <div className="w-20 h-20 bg-[#3B43AF] rounded-full flex items-center justify-center mx-auto mb-2">
                        <span className="text-3xl font-bold text-white">
                          {member.name.charAt(0)}
                        </span>
                      </div>
                      <p className="text-xs text-indigo-400 mt-2">Photo coming soon</p>
                    </div>
                  </div>
                )}
                
                {/* Overlay on hover */}
                <div className="absolute inset-0 bg-[#3B43AF]/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center rounded-3xl">
                  <div className="flex gap-3">
                    {member.email && (
                      <a 
                        href={`mailto:${member.email}`}
                        className="w-10 h-10 bg-white rounded-full flex items-center justify-center hover:scale-110 transition-transform"
                      >
                        <Mail className="w-5 h-5 text-[#3B43AF]" />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {/* Info */}
              <h3 className="text-xl font-bold text-gray-900 mb-1 group-hover:text-[#3B43AF] transition-colors">
                {member.name}
              </h3>
              <p className="text-[#3B43AF] font-medium mb-3">{member.role}</p>
              <p className="text-gray-600 text-sm leading-relaxed px-4">
                {member.bio}
              </p>
            </div>
          ))}
        </div>

        {/* Join the Team CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-gray-50 rounded-2xl p-8">
            <h3 className="text-xl font-bold text-gray-900 mb-2">Want to Join Our Team?</h3>
            <p className="text-gray-600 mb-4">We're always looking for friendly, hardworking people.</p>
            <a 
              href={`mailto:${companyInfo.email}?subject=Job Enquiry`}
              className="inline-flex items-center gap-2 text-[#3B43AF] font-semibold hover:gap-3 transition-all"
            >
              <Mail className="w-5 h-5" />
              Get in touch
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetTheTeam;
